import ApiService from '@/services/api'

// Recupera token do localStorage na inicialização
const token = localStorage.getItem('_token')
if (token && token.startsWith('Bearer ')) {
  const bearerToken = token.replace('Bearer ', '')
  ApiService.setAuthToken(bearerToken)
}

const state = {
  user: JSON.parse(localStorage.getItem('user-nexa')) || null,
  loading: false,
  error: null
}

const getters = {
  isAuthenticated: state => !!state.user,
  getUser: state => state.user,
  isLoading: state => state.loading,
  getError: state => state.error
}

const mutations = {
  SET_USER(state, user) {
    state.user = user
    localStorage.setItem('user-nexa', JSON.stringify(user))
  },
  SET_LOADING(state, loading) {
    state.loading = loading
  },
  SET_ERROR(state, error) {
    state.error = error
  },
  CLEAR_ERROR(state) {
    state.error = null
  },
  LOGOUT(state) {
    state.user = null
    state.error = null
    localStorage.removeItem('user-nexa')
    localStorage.removeItem('_token')
    ApiService.clearAuth()
  }
};

const actions = {
  /**
   * Registrar novo usuário
   * @param {object} userData - Dados do usuário
   */
  async register({ commit }, userData) {
    commit('SET_LOADING', true)
    commit('CLEAR_ERROR')
    
    try {
      const data = {
        usuario: userData.usuario,
        nome: userData.nome,
        email: userData.email,
        senha: userData.senha,
        confirmacao_senha: userData.confirmacao_senha
      }
      
      const response = await ApiService.post('/Usuarios/register', data)
      
      commit('SET_LOADING', false)
      return { success: true, data: response }
      
    } catch (error) {
      commit('SET_LOADING', false)
      commit('SET_ERROR', error.message || 'Erro ao registrar usuário')
      return { success: false, error: error.message || 'Erro ao registrar usuário' }
    }
  },

  /**
   * Login do usuário
   * @param {object} credentials - Credenciais de login
   */
  async login({ commit }, credentials) {
    commit('SET_LOADING', true)
    commit('CLEAR_ERROR')
    
    try {
      const data = {
        username: credentials.username,
        password: credentials.password
      }
      
      const response = await ApiService.post('/Usuarios/login', data)
      
      // Se a API retornar um token, configura a autenticação
      if (response.token) {
        // Salva o token no formato Bearer no localStorage
        localStorage.setItem('_token', `Bearer ${response.token}`)
        ApiService.setAuthToken(response.token)
      }
      
      // Salva os dados do usuário no state
      const userData = {
        username: credentials.username,
        token: response.token,
        ...response.user // outros dados do usuário que a API possa retornar
      }
      
      commit('SET_USER', userData)
      commit('SET_LOADING', false)
      
      return { success: true, data: response }
      
    } catch (error) {
      commit('SET_LOADING', false)
      
      // Extrai mensagem específica do erro
      let errorMessage = 'Erro ao fazer login'
      
      // O ApiService já trata e estrutura o erro, então acessamos diretamente
      if (error.message) {
        errorMessage = error.message
      } else if (error.response?.data?.message) {
        // Fallback para erro bruto do axios se não passou pelo handleError
        errorMessage = error.response.data.message
      } else if (typeof error === 'string') {
        errorMessage = error
      }
      
      commit('SET_ERROR', errorMessage)
      return { success: false, error: errorMessage }
    }
  },

  /**
   * Logout do usuário
   */
  logout({ commit }) {
    commit('LOGOUT')
  },

  /**
   * Limpar erro
   */
  clearError({ commit }) {
    commit('CLEAR_ERROR')
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
